{
  "pageTitle": "Setup Wizard",
  "welcomeDesc": "Let's get your account set up. It only takes a few minutes.",
  "stepNumber": "Step {{number}}",
  "selectProviderLabel": "Select a billing provider",
  "step1Title": "Bank Details",
  "step1Desc": "Add your bank account details for payment processing.",
  "step2Title": "Address",
  "step2Desc": "Add the address where bills are sent.",
  "step3Title": "Billing Provider",
  "step3Desc": "Connect your billing provider (electricity, internet, etc.).",
  "next": "Next",
  "back": "Back",
  "finish": "Complete Setup",
  "skip": "Skip for now",
  "bankName": "Bank name",
  "bankNamePlaceholder": "e.g. ASA, Procredit",
  "bankType": "Bank type",
  "bankASA": "ASA",
  "bankProcredit": "Procredit",
  "bankUsername": "Bank username",
  "bankUsernamePlaceholder": "Your bank username",
  "bankPassword": "Bank password",
  "bankPasswordPlaceholder": "Your bank password",
  "addressName": "Address name",
  "addressNamePlaceholder": "e.g. Home, Office",
  "selectProvider": "Select provider",
  "providerUsername": "Provider username",
  "providerUsernamePlaceholder": "Provider account username",
  "providerPassword": "Provider password",
  "providerPasswordPlaceholder": "Provider account password",
  "skipPayment": "Skip payment for this provider",
  "taxDeduction": "Enable tax deduction",
  "taxDeductionAmount": "Tax deduction amount (KM)",
  "loadingProviders": "Loading providers...",
  "creatingBank": "Creating bank...",
  "creatingAddress": "Creating address...",
  "assigningProvider": "Assigning provider...",
  "completingSetup": "Completing setup...",
  "bankCreated": "Bank details added",
  "addressCreated": "Address added",
  "providerAssigned": "Provider connected",
  "setupComplete": "Setup complete! Redirecting to dashboard...",
  "createBankError": "Failed to create bank",
  "createAddressError": "Failed to create address",
  "assignProviderError": "Failed to assign provider",
  "completeSetupError": "Failed to complete setup",
  "loadProvidersError": "Failed to load providers",
  "checkmark": "✓",
  "stepPlaceholder": "",
  "setupCompleteMsg": "Setup complete! Redirecting to dashboard..."
}
